import { ChangeDetectionStrategy, Component, EventEmitter, HostListener, Output } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslatePipe } from '@newroom-connect/library/pipes';

import { ButtonComponent } from '../buttons/button/button.component';
import { InputTextComponent } from '../inputs/input-text/input-text.component';

@Component({
  standalone: true,
  imports: [
    ReactiveFormsModule,
    ButtonComponent,
    InputTextComponent,
    TranslatePipe
  ],
  selector: 'nrc-sign-in-forgot-password-form',
  templateUrl: './sign-in-forgot-password-form.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SignInForgotPasswordFormComponent {
  @Output() public forgotPasswordEvent = new EventEmitter<any>();

  public isSubmitted = false;
  public forgotPasswordForm = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email])
  });

  /**
   * Emit continue event with the current sign up login form value.
   */
  @HostListener('document:keyup.enter')
  public forgotPassword(): void {
    this.isSubmitted = true;

    if (this.forgotPasswordForm.valid) {
      this.forgotPasswordEvent.emit(this.forgotPasswordForm.value as any);
    }
  }
}
